import React, { useRef } from "react";
import { YHDrawer } from "@/components/YhDrawer";
import { useTeamModel } from "../teamModel";
import { YhForm } from "@/components/YhFormBox";
import { IYhForm, IYhFormRef, FormItemTypeEnum } from "@/components/YhFormBox/Types";
import { ITeamDetail } from "../teamTypes";
import { message } from "antd";
import { getFormValidatorErrText } from "@/utils/utils";
import { divide } from "lodash";
import { useDictModel } from "../../dict/dictModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";
export function DetailDrawer() {
    const {
        visibleDrawer: { visible, mode },
        selectedRow,
        setVisibleDrawer,
        setIVisibleDrawer,
        editDetail,
        insertDetail,
        md5FormVal, setMd5FormVal
    } = useTeamModel();
    const { getTreeNodeName } = useDictModel()
    const formRef = useRef<IYhFormRef>();
    const onCancel = () => {
        setIVisibleDrawer()
        setMd5FormVal([])
    }
    const onSubmit = () => {
        // setIVisibleDrawer()
        formRef.current?.validateFields().then((val: any) => {
            let { columnCode } = val;
            let columnName = getTreeNodeName(columnCode)
            mode === "edit" ? editDetail({ ...val,columnName }) : insertDetail({ ...val, columnName })
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }
    const onSetFieldsValue = (formValues: { [key: string]: any }, isFormItem: boolean = true) => {
        setMd5FormVal(formValues.image)
    }
    const formConfig: IYhForm<ITeamDetail> = {
        formRef,
        labelCol: { span: 6 },
        // formValues: {},
        formValues: mode === "edit" || mode === "look" ? selectedRow[0] : {},
        items: [
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "标题",
                fieldName: "title",
                disable: mode === "look",
                rules: [{ required: true, message: "请输入标题" }]
            },
            {
                type: FormItemTypeEnum.FileImage,
                fieldLabel: "图片上传",
                fieldName: "image",
                // isOne: true,
                span: 24,
                md5List: md5FormVal,
                onSetFieldsValue
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                disable: mode === "look",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建人",
                fieldName: "createUser",
                span: 24,
                disable: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建时间",
                fieldName: "createTime",
                span: 24,
                disable: true
            },
        ]
    }
    return (
        <YHDrawer
            {...{
                title: `团队风采${mode === "add" ? '新增' : mode === "edit" ? '编辑' : '查看'}`,
                visible,
                onCancel,
                okText: "保存",
                onOk: onSubmit,
                showFooter: mode !== "look"
            }}
        >
            <YhForm {...formConfig} />
        </YHDrawer>
    )
}